import React from 'react';
import { Button } from 'reactstrap';

interface ChatFooterErrorPanelProps {
  title: string;
  body: string;
  dismissLabel: string;
  retryLabel: string;
  onDismiss: () => void;
  onRetry: () => Promise<void> | void;
}

export const ChatFooterErrorPanel: React.FC<ChatFooterErrorPanelProps> = ({
  title,
  body,
  dismissLabel,
  retryLabel,
  onDismiss,
  onRetry,
}) => {
  return (
    <div className="chatbot-footer-error-panel" role="alert" aria-live="assertive">
      <div className="chatbot-footer-error-title">
         <span className="chatbot-message-error-trigger">!</span>
        <span>{title}</span></div>
      <div className="chatbot-footer-error-body">{body}</div>
      <div className="chatbot-footer-error-actions">
        <Button
          color="link"
          className="chatbot-footer-error-action p-0 text-decoration-none"
          onClick={onDismiss}
        >
          {dismissLabel}
        </Button>
        <Button
          color="link"
          className="chatbot-footer-error-action p-0 text-decoration-none"
          onClick={() => {
            void onRetry();
          }}
        >
          {retryLabel}
        </Button>
      </div>
    </div>
  );
};
